import React, {Fragment} from "react";
import Separatore from "../../../../components/Spearatore";
import {getDataFormattata} from "../../../../utility/common";
import ContainerFoto from "../../../../components/ContainerFoto";
import {useSociUtils} from "../../../../hooks/useSociUtils";

export default function InfoSocioCertificatoView({
                                                     socio,
                                                 }) {

    const {getRigaInfoSocio} = useSociUtils({
        reloadFunction: () => {}
    });

    return (
        <Fragment>
            <Separatore>
                Informazioni socio
            </Separatore>
            {
                socio ? getRigaInfoSocio(socio, false, true) : ''
            }
            <hr className={"mt-4"}/>
            <br/>
            <Separatore>
                Documento d'Identità
            </Separatore>
            {
                socio && socio.documenti && socio.documenti.length > 0 &&
                <div className={"row text-center"}>
                    {
                        socio.documenti.map((doc, idx) =>
                            <div className={"col-md-3 rfi-container-border--sm m-2 text-center"} key={idx}>
                                <p>{doc ? doc.nome_file_originale || '' : ''}</p>
                                <ContainerFoto
                                    label={doc.label}
                                    content_type={doc.content_type}
                                    nome={doc.nome_file_originale}
                                    endpointContent={process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${doc.id_utente}/documento/${doc.id_documento_utente}`}
                                />
                                {
                                    doc.tipo_descr !== '' && doc.scadenza && doc.scadenza !== '' &&
                                    <Fragment>
                                        <p>
                                            <strong>{doc.tipo_descr}</strong><br/>scad.: {getDataFormattata(doc.scadenza)}
                                        </p>
                                    </Fragment>
                                }
                            </div>
                        )
                    }
                </div>
            }
        </Fragment>
    );
}